import { ButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(ButtonGroup)``;
